import { BankAccountStatus, ClientBankAccountModel } from '@skylab-shared/dataModel';

export interface ClientBankAccountsQLItem {
    number: string;
    bankName: string;
    status: BankAccountStatus;
    statusDate: Date | null;
    statusId: string | null;
}

export function getClientBankAccountQLItem(client: ClientBankAccountModel): ClientBankAccountsQLItem {
    return {
        number: client.number,
        bankName: client.bankName,
        status: client.status,
        statusDate: client.statusDate,
        statusId: client.statusId
    };
}
